export default Object.freeze({
  TITLE: 'e-mail 관리',
  TAB_ONE: 'e-mail 발송',
  TAB_TWO: 'e-mail 템플릿 설정',
  TAB_THREE: '자동e-mail 설정',
  TAB_FOUR: '자동e-mail 발송내역 조회',
  TAB_FIVE: '자동e-mail 사용내역 조회',
  DETAIL_ONE: 'ⓘ 자동 e-mail 발송을 설정할 수 있습니다.',
  DETAIL_TWO: 'Ⓘ 자동 e-mail 발송은 사용함/사용안함으로 발송 여부를 설정할 수 있습니다.',
  TABLE_TIT: '자동 e-mail 유형',
  TEMPLATE_GROUP: '템플릿구분',
  ENABLEDSTATUS: '사용여부',
  HELP_BTN: '치환 텍스트 보기',
  RESET_BTN: '기본 템플릿 복원',
  SEND_TEST_BTN: '테스트 전송',
  MAILFORM_SENDER: '발송 e메일 설정',
  MAILFORM_TITLE: '메일 제목',
  MAILFORM_TITLE_PLACEHOLDER: '메일 제목을 입력하세요.',
  MAILCONTENT_PLACEHOLDER: '메일 본문을 입력하세요.',
  USE_TEMPLATE: '사용',
  UNUSE_TEMPLATE: '사용 안 함',
  ONLY_EMAIL: '발송전용 e메일',
  CENTER_EMAIL: '고객센터 e메일',
  SAVE_BTN: '변경사항 저장',
  INTERCHANGE_GUIDE:
    'e-mail 발송 내용 설정 시 아래 치환텍스트를 이용하여 e-mail 수신자에게 알맞은 내용을 전송할 수 있습니다.',
  TH_1: '치환 텍스트',
  TH_2: '설명',
  TH_3: '예시',
  TH_4: '비고',
  HELP_TITLE: '치환텍스트 목록',
  SELECT_TEMPLATE: '톔플릿을 선택해 주세요.',
  ERR_TITLE_NULL: '메일 제목을 입력해 주세요.',
  ERR_CONTENT_NULL: '메일 템플릿을 입력해 주세요.',
  ERR_TEST: '테스트 메일 전송에 실패했습니다.',
  CONFIRM_CHANGE: '템플릿 변경 시 수정사항은 저장되지 않습니다. 템플릿을 변경하시겠습니까?',
  CHANGE_SUCCESS: '저장되었습니다.',
  TEST_SUCCESS: '{0} 운영자님의 e메일 주소로 테스트 전송이 완료 되었습니다.',
  MAIL_PARAMETERS: [
    { key: '${mall.mallName}', desc: '쇼핑몰명', example: '샘플몰', note: '쇼핑몰관리에서 설정한 쇼핑몰 명' },
    {
      key: '${mall.pcWebUrl}',
      desc: 'PC 웹 도메인',
      example: 'www.abcmall.com',
      note: '쇼핑몰관리에서 설정한 PC 웹 도메인',
    },
    {
      key: '${mall.mobileWebUrl}',
      desc: '모바일 웹 도메인',
      example: 'm.abcmall.com',
      note: '쇼핑몰관리에서 설정한 모바일 웹 도메인',
    },
    { key: '${member.memberName}', desc: '회원명', example: '홍길동', note: '' },
    { key: '${member.memberId}', desc: '회원 아이디', example: 'hongzzang', note: '' },
    {
      key: '${certNo}',
      desc: '비밀번호찾기 인증번호',
      example: 'ABCD1234',
      note: '시스템에 의해 자동 생성된 인증번호 발송\n',
    },
    { key: '${expireYmdt}', desc: '비밀번호찾기 만료일시', example: '2017년08월11일 15시 20분', note: '' },
    { key: '${mailSendYmdt}', desc: '비밀번호 변경일시', example: '2017년08월11일 15시 20분', note: '' },
    {
      key: '${tempPassword}',
      desc: '임시 비회원 주문 비밀번호\n',
      example: 'membermemberName',
      note: 'password12!!\n',
    },
    { key: '${url}', desc: '회원 비밀번호 초기화 링크', example: 'http://www.abc.mall~', note: '' },
    {
      key: '${code}',
      desc: '이메일 인증 코드',
      example: 'ABCD1234',
      note: '시스템에 의해 자동 생성된 인증번호 발송\n',
    },
    { key: '${prohibitionBeginYmd}', desc: '이용정지시작일', example: '2017년08월11일', note: '' },
    {
      key: '${prohibitionExpireYmd}',
      desc: '이용정지종료일',
      example: '2017년08월11일',
      note: '영구정지인 경우 \'기한없음\'으로 표시',
    },
    { key: '${prohibitionReason}', desc: '이용정지 사유', example: '욕설, 비방 사용', note: 'SA운영자 입력내용 표시' },
    { key: '${dormantDueYmdt}', desc: '휴면회원처리예정일시\n', example: '2017년08월11일 15시 20분', note: '' },
    { key: '${oauthType}', desc: '개인정보 수집출처', example: '페이코', note: '타 업체를 통해 개인정보를 수집한 경우(ex. 간편 로그인)  개인정보를 수집한 출처' },
    { key: '${expelYmdt}', desc: '강제탈퇴 일시', example: '2017년08월11일 15시 20분', note: '' },
    { key: '${expelReason}', desc: '강제탈퇴 사유', example: '해킹', note: 'SA운영자 입력내용 표시' },
    { key: '${smsAgreed}', desc: 'SMS 수신동의여부', example: '동의/비동의', note: '' },
    { key: '${smsAgreeYmdt}', desc: 'SMS수신동의설정 최종변경일시', example: '2017년08월11일 15시 20분', note: '' },
    { key: '${directMailAgreed}', desc: 'e메일 수신동의여부', example: '동의/비동의', note: '' },
    {
      key: '${directMailAgreeYmdt}',
      desc: 'e메일 수신동의설정 최종변경일시',
      example: '2017년08월11일 15시 20분',
      note: '',
    },
    { key: '${pushNotificationAgreed}', desc: '푸시 수신동의여부', example: '동의/비동의', note: '' },
    {
      key: '${pushNotificationAgreeYmdt}',
      desc: '푸시 수신동의설정 최종변경일시',
      example: '2017년08월11일 15시 20분',
      note: '',
    },
    { key: '${accumulationName}', desc: '적립금명', example: '마일리지', note: '쇼핑몰관리에서 설정한 적립금명' },
    { key: '${accumulations}', desc: '소멸예정 적립금 개수\n', example: '2개', note: '테이블 행 개수 계산용\n' },
    { key: '${accumulation.expireYmdt}', desc: '소멸예정 적립금 일시', example: '2017년08월11일 15시 20분', note: '' },
    { key: '${accumulation.accumulationAmt}', desc: '소멸예정 적립금 금액', example: '27,000', note: '' },
    { key: '${orderMail.bankName}', desc: '은행명', example: '우리은행', note: '' },
    { key: '${orderMail.bankDepositorName}', desc: '예금주명', example: '홍길동', note: '' },
    { key: '${orderMail.bankAccount}', desc: '가상계좌번호', example: '123-456-789', note: '' },
    {
      key: '${orderMail.limitPayYmdt}',
      desc: '가상계좌 입금기한 일시',
      example: '2017년08월11일 15시 20분',
      note: '쇼핑몰 무통장: 미입금주문 자동취소일 은행가상계좌: 미입금주문 자동취소일 / 가상계좌 만기일 중 짧은 것',
    },
    { key: '${orderMail.registerYmdt}', desc: '주문일시', example: '2017년08월11일 15시 20분', note: '' },
    { key: '${orderMail.orderNo}', desc: '주문번호', example: '123456789', note: '' },
    {
      key: '${orderMail.orderProductOptions.productName}',
      desc: '상품명',
      example: '뽀송뽀송 아기 속옷',
      note: '최대 20byte(한글: 10자, 영문/숫자: 20자)까지 표시 후, 줄임말(...)처리',
    },
    { key: '${orderMail.orderProductOptions.displayOptionName}', desc: '옵션명', example: '라벤더', note: '' },
    { key: '${orderProductOption.optionValue}', desc: '옵션값', example: '빨강', note: '상품 옵션 값' },
    { key: '${orderProductOption.userInputText}', desc: '구매자작성형 옵션', example: '구성품 2개', note: '' },
    {
      key: '${orderMail.orderProductOptions.immediateDiscountedPrice}',
      desc: '할인적용가',
      example: '25,000',
      note: '',
    },
    { key: '${orderMail.orderProductOptions.orderCnt}', desc: '주문수량', example: '2', note: '' },
    {
      key: '${orderMail.orderProductOptions.immediateDiscountedAmt}',
      desc: '상품합계 금액',
      example: '50,000',
      note: '',
    },
    { key: '${orderMail.totalPayAmt}', desc: '적립금+실결제금액', example: '55,000', note: '' },
    { key: '${orderMail.subPayAmt}', desc: '적립금', example: '5,000', note: '' },
    { key: '${orderMail.mainPayAmt}', desc: '실결제금액', example: '50,000', note: '' },
    { key: '${orderMail.totalDeliveryAmt}', desc: '배송비', example: '5,000', note: '' },
    {
      key:
        '${orderMail.lastAdditionalDiscountAmt + orderMail.lastCartCouponDiscountAmt + orderMail.lastProductCouponDiscountAmt + orderMail.lastDeliveryCouponDiscountAmt}',
      desc: '할인금액',
      example: '25,000',
      note: '',
    },
    { key: '${orderMail.payTypeLabel}', desc: '결제수단명', example: '신용카드', note: '' },
    { key: '${orderMail.receiverName}', desc: '수령자명', example: '홍길동', note: '' },
    { key: '${orderMail.receiverContact1}', desc: '수령자 연락처', example: '010-1234-5678', note: '' },
    {
      key: '${orderMail.address}',
      desc: '수령자 주소',
      example: '경기도 성남시 분당구 …',
      note: '최대 20byte(한글: 10자, 영문/숫자: 20자)까지 표시 후, 줄임말(...)처리',
    },
    { key: '${orderProductOption.orderCnt}', desc: '주문수량', example: '2', note: '' },
    { key: '${orderMail.deliveryCompanyTypeLabel}', desc: '택배사명', example: 'CJ대한통운', note: '' },
    { key: '${orderMail.invoiceNo}', desc: '송장번호', example: '12345678', note: '' },
    { key: '${orderMail.refundProductAmt}', desc: '환불 상품금액', example: '25,000', note: '' },
    { key: '${orderMail.refundDeliveryAmt}', desc: '환불 배송비금액', example: '5,000', note: '' },
    { key: '${orderMail.refundSubtractionAmt}', desc: '환불 차감금액', example: '5,000', note: '' },
    { key: '${orderMail.refundPayAmt}', desc: '환불금액', example: '20,000', note: '적립금 포함 금액' },
    { key: '${orderMail.refundSubPayAmt}', desc: '적립금 환불금액', example: '3,000', note: '' },
    { key: '${orderMail.extraData}', desc: '몰 추가정보(API 기준)', example: '', note: '' },
    {
      key: '${inquiry.inquiryContent}',
      desc: '1:1문의 문의내용',
      example: '언제 배송오는건가요?....',
      note: '최대 20byte(한글: 10자, 영문/숫자: 20자)까지 표시 후, 줄임말(...)처리',
    },
    {
      key: '${answerContent}',
      desc: '1:1문의 답변내용',
      example: '안녕하세요 고객님. 불편을 드려..',
      note: '최대 20byte(한글: 10자, 영문/숫자: 20자)까지 표시 후, 줄임말(...)처리',
    },
    { key: '${inquiryCd}', desc: '상품문의 문의유형\n', example: '주문', note: '' },
    { key: '${registerYmdt}', desc: '상품문의 문의일시', example: '2017년08월11일 15시20분', note: '' },
    { key: '${mallProductNo}', desc: '상품문의 상품번호', example: 'A12345', note: '' },
    {
      key: '${productName}',
      desc: '상품문의 상품명',
      example: '뽀송뽀송 아기 속옷',
      note: '최대 20byte(한글: 10자, 영문/숫자: 20자)까지 표시 후, 줄임말(...)처리',
    },
    {
      key: '${content}',
      desc: '상품문의 문의내용',
      example: '언제 재입고 되나요?...',
      note: '최대 20byte(한글: 10자, 영문/숫자: 20자)까지 표시 후, 줄임말(...)처리',
    },
    {
      key: '${replyContent}',
      desc: '상품문의 답변내용',
      example: '안녕하세요 고객님. 해당 상품은..',
      note: '최대 20byte(한글: 10자, 영문/숫자: 20자)까지 표시 후, 줄임말(...)처리',
    },
    { key: '${replyRegisterYmdt}', desc: '상품문의 답변일시', example: '2017년08월11일 15시20분', note: '' },
    {
      key: '${mall.serviceCenterPhoneNo}',
      desc: '쇼핑몰 고객센터 전화번호',
      example: '02-0000-0000',
      note: '쇼핑몰관리에서 설정한 고객센터 전화번호',
    },
    {
      key: '${service.companyName}',
      desc: '서비스 회사명',
      example: 'NHN엔터테인먼트',
      note: '기초정보 관리에서 설정한 회사명',
    },
    {
      key: '${service.representativeName}',
      desc: '서비스 대표명',
      example: '정우진',
      note: '기초정보 관리에서 설정한 대표자명',
    },
    {
      key: '${service.businessRegistrationNo}',
      desc: '서비스 사업자등록번호',
      example: '144-81-15549',
      note: '기초정보 관리에서 설정한 사업자등록번호',
    },
    {
      key: '${service.onlineMarketingBusinessDeclarationNo}',
      desc: '서비스 통신판매업신고번호',
      example: '제 2013-경기성남-1067호',
      note: '기초정보 관리에서 설정한 통신판매업신고번호',
    },
    {
      key: '${service.privacyManagerName}',
      desc: '서비스 개인정보관리책임자 명',
      example: '김현성',
      note: '기초정보 관리에서 설정한 개인정보 관리 책임자명',
    },
    {
      key: '${service.zipCd}',
      desc: '서비스 주소우편번호',
      example: '13487',
      note: '기초정보 관리에서 설정한 주소정보',
    },
    {
      key: '${service.address}',
      desc: '서비스 신주소',
      example: '경기도 성남시 분당구 대왕판교로 645번길 16',
      note: '기초정보 관리에서 설정한 주소정보',
    },
    {
      key: '${service.addressDetail}',
      desc: '서비스 신주소상세',
      example: '플레이 뮤지엄',
      note: '기초정보 관리에서 설정한 주소정보',
    },
    {
      key: '${service.jibunAddress}',
      desc: '서비스 지번주소',
      example: '경기도 성남시 분당구 삼평동 629',
      note: '기초정보 관리에서 설정한 주소정보',
    },
    {
      key: '${service.jibunAddressDetail}',
      desc: '서비스 지번주소 상세',
      example: '플레이뮤지엄',
      note: '기초정보 관리에서 설정한 주소정보',
    },
    {
      key: '${mail.autoDepositDate}',
      desc: '정기배송 결제 예정일',
      example: '22',
      note: '고객이 신청한 정기배송일',
    },
    {
      key: '${mail.autoDepositPay}',
      desc: '정기배송 결제 예정 금액',
      example: '27,000',
      note: '정기결제 신청 내역 합산 금액',
    },
    {
      key: '${ProductOptions.productName}',
      desc: '정기배송 결제 예정 상품명',
      example: '뽀송뽀송 아기 속옷',
      note: '최대 20byte(한글: 10자, 영문/숫자: 20자)까지 표시 후, 줄임말(...)처리',
    },
    {
      key: '${ProductOptions.displayOptionName}',
      desc: '정기배송 결제 예정 옵션명',
      example: '라벤더',
      note: '옵션명 최대 5개까지 등록가능\n옵션명 25자/ 옵션값 50자까지 입력 가능',
    },
    {
      key: '${ProductOption.userInputText}',
      desc: '정기배송 결제 예정 구매자작성형 옵션',
      example: '구성품 2개',
      note: '',
    },
    {
      key: '${ProductOptions.immediateDiscountedPrice}',
      desc: '할인적용가',
      example: '25,000',
      note: '',
    },
    {
      key: '${ProductOptions.orderCnt}',
      desc: '주문수량',
      example: '2',
      note: '',
    },
    {
      key: '${ProductOptions.immediateDiscountedAmt}',
      desc: '상품합계 금액',
      example: '50,000',
      note: '',
    },
    {
      key: '${notificationDate}',
      desc: '메일발송일',
      example: '2017년08월11일',
      note: '',
    },
  ],
});
